import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { District, Nullish, Sport, State } from 'types'
import { FEATURE_NAME, IState } from '../Filters.model'

const initialState: IState = {
  state: null,
  district: null,
  sport: null,
  isOverall: true,
}

export const filtersSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setFilterState: (state, action: PayloadAction<State>) => {
      state.state = action.payload
    },
    setFilterDistrict: (state, action: PayloadAction<Nullish<District>>) => {
      state.district = action.payload
    },
    setFilterSport: (state, action: PayloadAction<Nullish<Sport>>) => {
      state.sport = action.payload
    },
    setFilterIsOverall: (state, action: PayloadAction<boolean>) => {
      state.isOverall = action.payload
    },
  },
})

export const { setFilterState, setFilterDistrict, setFilterSport, setFilterIsOverall } =
  filtersSlice.actions
